import React, { createContext, useState, useRef } from 'react';

const WebSocketContext = createContext();  // Create the context

const SYSTEM_MESSAGE = 2; // message_type 2, see Message::postSystemNotification in the API

// Pops a native OS/browser notification for a genuine incoming chat message
// (event_type 1 = new message, see Message::publishMessage in the API).
// Skipped while the tab is already visible and focused, since the in-app
// unread badge/toast covers that case.
const showBrowserNotification = (data) => {
  if (data?.event_type !== 1) return;
  if (data?.message_type === SYSTEM_MESSAGE) return;
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible' && document.hasFocus()) return;

  const title = data?.thread_summary?.thread_title || data?.message_from_label || 'New message';
  const body = (data?.message_body || '').slice(0, 120);
  const notification = new Notification(title, {
    body,
    icon: `${process.env.PUBLIC_URL}/favicon.ico`,
    tag: data?.thread_slug || data?.slug,
  });
  notification.onclick = () => {
    window.focus();
    const threadSlug = data?.thread_slug;
    window.location.href = threadSlug
      ? `${process.env.PUBLIC_URL}/inbox?thread=${threadSlug}`
      : `${process.env.PUBLIC_URL}/inbox`;
    notification.close();
  };
};

export const WebSocketProvider = ({ children }) => {
  const socketData = useRef([]);
  const [newMessageReceived, setNewMessageReceived] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const handleWebSocketEvent = (data, role_id) => {
    if(data === -1){
      socketData.current = [];
    } else {
      socketData.current = [...socketData.current, data];
      const unreadRecognizer = (role_id === 1 && data?.message_from === 4) || (role_id === 3 && data?.message_from === 3) || (role_id === 5 && data?.message_from === 6)
      if(!unreadRecognizer) {
        setNewMessageReceived(1);
        showBrowserNotification(data);
      }
    }
    setRefresh(pre => !pre)
  };

  return (
    <WebSocketContext.Provider value={{ socketData, newMessageReceived, setNewMessageReceived, handleWebSocketEvent }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketContext;  // Export the context itself
